<script lang="ts">
  import { onMount } from 'svelte';
  import { register } from 'swiper/element/bundle';
  import { getAppConfig } from '../../common/config/app-config';
  import { getGuestToken } from '../../common/services/ajax-services';
  import { isMobileUIExperience } from '../../common/util';
  import { getProductsByRuleContextFromAlgoliaAsync } from '../common/services/algolia';
  import { getDataFromAmplienceAsync, getDataFromAmplienceAsyncByKey } from '../common/services/amplience';
  import { getCMSComponentsFromHybrisAsync } from '../common/services/hybris';
  import { getModifiedAlgoliaSingleHit } from '../common/services/rich-relevance';
  import AppFooterPage from '../footer/AppFooterPage.svelte';
  import BlogCommonContent from './components/BlogCommonContent.svelte';
  import BlogDetailPageWrapper from './components/BlogDetailPageWrapper.svelte';
  import BlogFilter from './components/BlogFilter.svelte';
  import BlogFilterPage from './components/BlogFilterPage.svelte';
  import BlogHeader from './components/BlogHeader.svelte';
  import BlogLandingPage from './components/BlogLandingPage.svelte';
  import { blogActiveFilter, blogFilterHeading } from './store/blog_store';

  const { blogCategoryID, blogPostId, extraAmplienceBlogData, svelteModuleFooterEnabled } = getAppConfig();
  let blogCategoryData;
  let allBlogData: any;
  let blogDataByDesignType: any;
  let blogFilterData: any;
  let blogDetailData: any;
  let blogBanner: any;
  let blogCarousalData = [];
  const blogBannerComponentUid = 'extraBlogServicesAmplienceComponent';
  const isExtraAmplienceBlogDataAvailable = extraAmplienceBlogData && extraAmplienceBlogData.length;
  let isBlogLandingPage = (!blogCategoryID && !blogPostId) || blogCategoryID === 'all';
  let isBlogFilterPage = blogCategoryID && blogCategoryID !== 'all' && !blogPostId;
  const isBlogDetailPage = blogCategoryID && blogCategoryID !== 'all' && blogPostId;
  const isAppExperience = isMobileUIExperience();

  onMount(async () => {
    register();
    await getGuestToken();
    if (isBlogDetailPage) {
      getBlogDetailsData();
    } else {
      getBlogCatData();
      getAllBlogData();
      if (isBlogLandingPage) {
        getBlogLandingBannerData();
      }
    }

    if (!isBlogDetailPage && !isAppExperience) {
      window['ACC'].mixpanel.trackBlogPageViewed('Blogs Home Page Viewed', '', '');
      window['ACC'].extragtm.trackBlogPageView();
    }
  });

  const getAllBlogData = () => {
    if (isBlogFilterPage && isExtraAmplienceBlogDataAvailable) {
      blogFilterData = extraAmplienceBlogData;
      // blogFilterHeading.set(blogCategoryID?.replace(/-/g, ' '));
    } else {
      allBlogData = isExtraAmplienceBlogDataAvailable ? extraAmplienceBlogData : null;
      blogDataByDesignType =
        allBlogData && allBlogData.length ? Object.groupBy(allBlogData, (x: any) => x.blogDesignType) : null;
    }
  };

  const getBlogCatData = () => {
    window['ACC'].loader.showLoader();
    const blogCatAmplienceId = '99477105-ccd5-4d29-8562-4af5d752a512';
    return getDataFromAmplienceAsync(blogCatAmplienceId).then(blogCatData => {
      blogCategoryData = blogCatData;
      if (isBlogFilterPage) {
        blogActiveFilter.set(blogCategoryID);
        const category = blogCategoryData?.body?.categoryList?.find(({ id }) => id === blogCategoryID);
        if (category) {
          blogFilterHeading.set(category?.category);
        }
      } else {
        blogActiveFilter.set('all');
        isBlogLandingPage = true;
        isBlogFilterPage = false;
      }
      window['ACC'].loader.hideLoader();
    });
  };

  const getBlogDetailsData = () => {
    window['ACC'].loader.showLoader();
    return getDataFromAmplienceAsyncByKey(blogPostId).then((detailData: any) => {
      blogDetailData = detailData && detailData?.body ? detailData.body : null;
      if (blogDetailData && blogDetailData?.shopbyarticle) {
        getBlogCarousalData();
      }
      window['ACC'].loader.hideLoader();
    });
  };

  const getBlogLandingBannerData = () => {
    return getCMSComponentsFromHybrisAsync([blogBannerComponentUid]).then(data => {
      if (data && data.component && data.component.length) {
        blogBanner = data.component[0];
        // return getDataFromAmplienceAsync(data.component[0].amplienceId).then((bannerData: any) => {
        // })
      }
    });
  };

  function prepareAlgoliaHitsForComponent(hitsArray: any[]) {
    return hitsArray.map((h, i) => getModifiedAlgoliaSingleHit(h, i));
  }

  function getBlogCarousalData() {
    window['ACC'].loader.showLoader();

    getProductsByRuleContextFromAlgoliaAsync(blogDetailData?.shopbyarticle)
      .then((res: any) => res.hits || [])
      .then(hits => prepareAlgoliaHitsForComponent(hits))
      .then(preparedHits => {
        blogCarousalData = preparedHits;
        window['ACC'].loader.hideLoader();
      });
  }
</script>

<section class="blog-page-container">
  {#if isBlogLandingPage}
    <BlogCommonContent>
      <BlogHeader />
    </BlogCommonContent>
    {#if blogCategoryData && blogCategoryData.body && blogCategoryData.body.categoryList && blogCategoryData.body.categoryList.length}
      <BlogCommonContent>
        <BlogFilter blogCategories={blogCategoryData?.body?.categoryList} />
      </BlogCommonContent>
    {/if}
    {#if blogDataByDesignType}
      <BlogLandingPage {blogDataByDesignType} {blogBanner} />
    {/if}
  {:else if isBlogFilterPage}
    <BlogCommonContent>
      <BlogHeader />
    </BlogCommonContent>
    {#if blogCategoryData && blogCategoryData.body && blogCategoryData.body.categoryList && blogCategoryData.body.categoryList.length}
      <BlogCommonContent>
        <BlogFilter blogCategories={blogCategoryData?.body?.categoryList} />
      </BlogCommonContent>
    {/if}
    {#if blogFilterData && blogFilterData.length}
      <BlogFilterPage {blogFilterData} />
    {/if}
  {:else if isBlogDetailPage}
    <BlogCommonContent>
      <BlogHeader />
    </BlogCommonContent>
    {#if blogDetailData}
      <BlogDetailPageWrapper {blogDetailData} {blogCarousalData} />
    {/if}
  {/if}
</section>
{#if svelteModuleFooterEnabled && !isAppExperience}
  <AppFooterPage />
{/if}

<style lang="scss">
  @import '../common/styles/colors.new.scss';

  .blog-page-container {
    background: $primary-white;
    display: flex;
    flex-direction: column;
    gap: 60px;
    @include desktop-max-width {
      gap: 30px;
      overflow: hidden;
    }
  }
  :global(#blog-page) {
    min-height: auto !important;
  }
</style>
